<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>客户报备</h1>
        <p>报备只锁定还没注册的客户。已经用邀请码注册绑定的用户不能在这里改归属。标准保护期 90 天，从审核通过起算。</p>
      </div>
      <div class="ch-actions">
        <button class="ch-btn gold" type="button" @click="create">新建报备</button>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">我的报备</div><div class="v">{{ list.length }} 条</div></div>
      <div class="ch-metric"><div class="k">待审核</div><div class="v">{{ count('PENDING') }} 条</div></div>
      <div class="ch-metric"><div class="k">保护期中</div><div class="v">{{ count('PROTECTED') }} 条</div><div class="s">{{ ending }} 条将在 30 天内到期</div></div>
    </div>
    <div class="ch-panel">
      <table class="ch-table">
        <thead><tr><th>客户名称</th><th>类型</th><th>预估年采购额</th><th>备注</th><th>提交时间</th><th>保护期截止</th><th>剩余</th><th>状态</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>{{ row.customerName }}</td>
            <td>{{ row.customerType }}</td>
            <td>{{ row.estimatedAmount != null ? '¥ ' + yuan(row.estimatedAmount) : '—' }}</td>
            <td>{{ row.remark || '—' }}</td>
            <td>{{ clock(row.createdAt) }}</td>
            <td>{{ row.protectUntil || '—' }}</td>
            <td>{{ remain(row) }}</td>
            <td><span class="ch-tag" :class="row.status === 'PROTECTED' ? 'ok' : (row.status === 'REJECTED' ? 'bad' : 'warn')">{{ statusName(row.status) }}</span></td>
            <td>
              <button class="ch-link" type="button" @click="edit(row)">修改</button>
              <button class="ch-link" type="button" @click="remove(row)">删除</button>
            </td>
          </tr>
          <tr v-if="!list.length"><td colspan="9" class="ch-empty">还没有报备</td></tr>
        </tbody>
      </table>
    </div>
    <el-dialog :title="form.id ? '修改客户报备' : '新建客户报备'" :visible.sync="open" width="460px">
      <div class="report-form">
        <label>客户名称 *
          <input v-model.trim="form.customerName" placeholder="请输入客户名称" />
        </label>
        <label>客户类型
          <select v-model="form.customerType">
            <option value="企业客户">企业客户</option>
            <option value="个人客户">个人客户</option>
            <option value="战略客户">战略客户</option>
          </select>
        </label>
        <label>预估年采购额
          <input v-model.trim="form.estimatedAmount" placeholder="选填，单位元" />
        </label>
        <label>备注
          <textarea v-model.trim="form.remark" rows="3" maxlength="500" placeholder="总部审核时能看到" />
        </label>
      </div>
      <p class="ch-note">同一客户在保护期内不能重复报备。备注会给总部看。战略客户延长保护期需要总部审批，当前提交按标准 90 天。</p>
      <div slot="footer">
        <el-button size="small" @click="open = false">取消</el-button>
        <el-button size="small" type="primary" @click="submit">{{ form.id ? '保存' : '提交报备' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getChannelReports, saveChannelReport } from '@/api/admin'
import { statusName, yuan } from './labels'

export default {
  name: 'PartnerReports',
  data() {
    return { list: [], open: false, form: { id: null, customerName: '', customerType: '企业客户', estimatedAmount: '', remark: '' } }
  },
  computed: {
    ending() {
      const limit = Date.now() + 30 * 86400000
      return this.list.filter(item => item.status === 'PROTECTED' && item.protectUntil && new Date(item.protectUntil).getTime() <= limit).length
    }
  },
  created() { this.load() },
  methods: {
    statusName, yuan,
    count(status) { return this.list.filter(item => item.status === status).length },
    remain(row) {
      if (!row.protectUntil) return '—'
      const days = Math.ceil((new Date(row.protectUntil).getTime() - Date.now()) / 86400000)
      return days >= 0 ? days + ' 天' : '已到期'
    },
    clock(value) {
      if (!value) return '—'
      return String(value).replace('T', ' ').slice(0, 19)
    },
    blankForm() {
      return { id: null, customerName: '', customerType: '企业客户', estimatedAmount: '', remark: '' }
    },
    create() {
      this.form = this.blankForm()
      this.open = true
    },
    edit(row) {
      this.form = {
        id: row.id,
        customerName: row.customerName || '',
        customerType: row.customerType || '企业客户',
        estimatedAmount: row.estimatedAmount != null ? String(row.estimatedAmount) : '',
        remark: row.remark || ''
      }
      this.open = true
    },
    async load() {
      const result = await getChannelReports()
      this.list = result.list || []
    },
    async submit() {
      const customerName = (this.form.customerName || '').trim()
      if (!customerName) {
        this.$message.warning('请填写客户名称')
        return
      }
      const editing = !!this.form.id
      await saveChannelReport({
        id: this.form.id,
        customerName,
        customerType: this.form.customerType,
        estimatedAmount: (this.form.estimatedAmount || '').trim(),
        remark: (this.form.remark || '').trim()
      })
      this.open = false
      this.form = this.blankForm()
      this.$message.success(editing ? '已保存' : '已提交，等待总部审核')
      this.load()
    },
    async remove(row) {
      try {
        await this.$confirm('删除「' + row.customerName + '」这条报备？', '删除报备', { type: 'warning' })
      } catch (e) {
        return
      }
      await saveChannelReport({ id: row.id, action: 'delete' })
      this.$message.success('已删除')
      this.load()
    }
  }
}
</script>

<style scoped>
.report-form { display: flex; flex-direction: column; gap: 12px; }
.report-form label { display: flex; flex-direction: column; gap: 6px; color: #344054; font-size: 13px; }
.report-form input, .report-form select, .report-form textarea {
  border: 1px solid #d5dced;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13px;
  color: #1d2939;
  background: #fff;
}
</style>
